<template>
  <v-dialog v-model="dialogFactura" persistent max-width="1500px">
    <v-card>
      <v-card-title class="headline">Detalles de Factura</v-card-title>
      <v-card-text>
        <v-container>
          <v-overlay :value="isLoading" v-if="isLoading" absolute class="loading-overlay">
            <v-row justify="center" align="center" class="fill-height">
              <v-col class="text-center">
                <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
              </v-col>
            </v-row>
          </v-overlay>
          <template v-if="!isLoading">
            <v-card class="mb-3" >
            <v-card-title class="headline">Liquidación</v-card-title>
            <v-card-text>
              <v-row class="d-flex flex-row">
                <v-col cols="3" class="pr-1">
                  <v-text-field label="Identificador" v-model="factura.identificador" readonly></v-text-field>
                </v-col>
                <v-col cols="3" class="pr-1">
                  <v-text-field label="Sucursal" v-model="factura.sucursal" readonly></v-text-field>
                </v-col>
                <v-col cols="3" class="pr-1">
                  <v-text-field label="No. Liquidación" v-model="factura.numeroLiquidacion" readonly></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field label="RUC" v-model="factura.ruc" readonly></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Facturas -->
          <v-card class="mb-3">
            <v-card-title class="headline">Facturación</v-card-title>
            <v-card-text v-for="(facturaItem, index) in factura.facturas" :key="index">
              <v-row class="d-flex flex-row">
                <v-col cols="4" class="pr-1">
                  <v-text-field label="N°. Factura" v-model="facturaItem.NumeroFactura" readonly></v-text-field>
                </v-col>
                <v-col cols="4" class="pr-1">
                  <v-text-field label="Fecha de Emisión" v-model="facturaItem.FechaEmision" readonly></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field label="Clave de Acceso" v-model="facturaItem.ClaveAcceso" readonly></v-text-field>
                </v-col>
              </v-row>
              <!-- Añade más campos según sea necesario -->
            </v-card-text>
          </v-card>

          <!-- Contabilización -->
          <v-card class="mb-3">
            <v-card-title class="headline">Contabilización</v-card-title>
            <v-card-text v-for="(contabilizacionItem, index) in factura.contabilizacion" :key="index">
              <v-row class="d-flex flex-row">
                <v-col cols="6">
                  <v-text-field label="No. Retención" v-model="contabilizacionItem.NumeroRetencion"
                    readonly></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field label="Nro Comprobante" v-model="contabilizacionItem.AsientoContable"
                    readonly></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Pago -->
          <v-card class="mb-3">
            <v-card-title class="headline">Pago</v-card-title>
            <v-card-text v-for="(pagoItem, index) in factura.pago" :key="index">
              <v-row class="d-flex flex-row">
                <v-col cols="12">
                  <v-text-field label="No. Transferencia Bancaria" v-model="pagoItem.NumeroTransferenciaBancaria"
                    readonly></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-card-title class="headline">Detalles del Contacto</v-card-title>
            <v-card-text>
              <v-row class="d-flex flex-row">
                <v-col cols="6">
                  <v-text-field label="Correo Electrónico APS" v-model="factura.correoElectronicoAPS"
                    readonly></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
      
          </template>
           </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="closeDialog">Cerrar</v-btn>
      </v-card-actions>
      
    </v-card>
    
  </v-dialog>
</template>

<script>
import serviceFactura from '@/services/FacturaServices';

export default {
  name: "FacturaVisualizaDialog",
  props: {
    show: Boolean,
    numeroLiquidacion: String,
    tipo: Number,
  },
  data() {
    return {
      dialogFactura: this.show,
      isLoading: false,  // Variable de estado de carga
      factura: {
        identificador: '',
        sucursal: '',
        numeroLiquidacion: '',
        ruc: '',
        facturas: [],
        contabilizacion: [],
        pago: [],
        correoElectronicoAPS: ''
      },
    };
  },
  methods: {
    async loadFacturaData() {
      this.isLoading = true;  // Mostrar indicador de carga
      try {
        const response = await serviceFactura.GetAllDataFactura(this.numeroLiquidacion, this.tipo);
        const data = response.data.Data;
        this.factura = {
          identificador: data.Identificador,
          sucursal: data.Sucursal,
          numeroLiquidacion: data.NumeroLiquidacion,
          ruc: data.RUC,
          facturas: data.Facturas,
          contabilizacion: data.Contabilizacion,
          pago: data.Pago,
          correoElectronicoAPS: data.CorreoElectronicoAPS,
        };

      } catch (error) {
        this.isLoading = false;
      }
      this.isLoading = false;
      
    },
    closeDialog() {
      this.dialogFactura = false; // Cierra el diálogo
      this.$emit('close');  // Asegúrate de emitir el evento para actualizar la prop show
    }
  },
  watch: {
    show(val) {
      this.dialogFactura = val; // Sincronizar con la prop
      if (val) {
        
        this.loadFacturaData(); // Cargar datos cuando se abre

      }
    },
    dialogFactura(val) {
      this.$emit('update:show', val); // Emitir cambio para la prop
    },
  },
};
</script>
<style >
.loading-overlay {
  position: absolute; /* Establecer posición absoluta */
  z-index: 2000 !important; /* Asegúrate de que el z-index sea mayor */
  background-color: rgba(255, 255, 255, 0.8); /* Fondo semi-transparente */
  width: auto; /* Asegúrate de que ocupe todo el espacio */
  height: auto; /* Asegúrate de que ocupe todo el espacio */
  padding-left: 50%;
}
.fill-height {
  height: 100%; /* Asegúrate de que el row ocupe todo el espacio */
}
</style>
